import { FormToContact } from "../components/Contacts/DetailsScreens/Webforms";
import Configs from "../config";
import {
  AddAndRemoveMultipleLabelsContactIRoute,
  IContactTag,
  ISetTestDriveContactIRoute,
} from "../generated/Api";
import { ImportExistingEmail } from "../pages/contacts/import-emails";
import { ContactStatus, IContact } from "../types/Contact";
import { ITagQuery } from "../types/TagQueryTypes";
import { DefaultResponse } from "../types/UtilTypes";
import { getVisitorId } from "../utils/FingerPrint";
import { localStorageGetItem } from "../utils/LocalStorage";

export interface ICreateContact {
  name?: string;
  email: string;
  labels: string[];
  tags: any[];
  avatar: string;
  status: ContactStatus;
  phone?: string;
}

export interface IUpdateContact {
  name?: string;
  email?: string;
  labels?: string[];
  tags?: IContactTag[];
  avatar?: string;
  customFields?: { [key: string]: any };
  phone?: string;
  firstName?: string;
  lastName?: string;

  billingStreet1?: string;
  billingStreet2?: string;
  billingCity?: string;
  billingCountry?: string;
  billingState?: string;
  billingPostalCode?: string;
  billingPhoneCountryCode?: string;
  billingPhone?: string;
  billingFullAddress?: string;
  billingPlaceId?: string;
  billingStreetNumber?: string;

  shippingStreet1?: string;
  shippingStreet2?: string;
  shippingCity?: string;
  shippingCountry?: string;
  shippingState?: string;
  shippingPostalCode?: string;
  shippingPhoneCountryCode?: string;
  shippingPhone?: string;
  shippingFullAddress?: string;
  shippingPlaceId?: string;
  shippingStreetNumber?: string;

  testimonial?: string;
}

export interface IUpdateContactResponse {
  count: number;
}

interface IDeleteContact {
  deleted: number;
}

export interface FindAllContactWithFilterIRoute {
  limit?: number;
  offset?: number;
  labels?: string[];
  status?: ContactStatus[];
  email?: number;
  name?: number;
  phone?: number;
  createdAt?: number;
  statusOrder?: number;
  search?: string;
  tagQuery?: ITagQuery;

  //Only on campaign screen
  campaignId?: string;
  onlyActive?: boolean;
}

// CRIEI ISSO AQUI PQ TAVA DANDO UM PAU MUITO AVULSO SÓ NO MEU PC -- GABIRU
const create = async (body: ICreateContact): Promise<IContact> => {
  const visitorId = await getVisitorId();
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/contact`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      "X-Visitor-Id": visitorId,
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({
      ...body,
      userUid,
    }),
  });

  const contact: DefaultResponse<IContact> = await response.json();
  if (contact.status === "ok") {
    return contact.data as IContact;
  }

  throw new Error(contact.code);
};

const read = async (
  data: FindAllContactWithFilterIRoute,
  signal?: AbortSignal
): Promise<{ total: number; contacts: IContact[] }> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");

  const response = await fetch(
    `${Configs.SERVER_URL}/contact/userUidx/${userUid}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
      signal,
    }
  );

  const contacts: DefaultResponse<{ total: number; contacts: IContact[] }> =
    await response.json();
  if (contacts.status === "ok") {
    return contacts.data as { total: number; contacts: IContact[] };
  }

  throw new Error(contacts.code);
};

const checkDeleteCount = async ({
  contactIds,
  query,
}: {
  contactIds?: string[];
  query?: FindAllContactWithFilterIRoute;
}): Promise<{ contatcsToBeDeletedCount: number }> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/checkDeleteCount`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ contactIds, query, userUid }),
    }
  );

  const responseData: DefaultResponse<{ contatcsToBeDeletedCount: number }> =
    await response.json();
  if (responseData.status === "ok") {
    return responseData.data as { contatcsToBeDeletedCount: number };
  }

  throw new Error(responseData.code);
};

const countContactsByTagQueries = async (
  tagQueries: ITagQuery[]
): Promise<number[]> => {
  const visitorId = await getVisitorId();
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/userUid/${userUid}/count/tagQuery`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "X-Visitor-Id": visitorId,
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ tagQueries }),
    }
  );

  const contacts: DefaultResponse<number[]> = await response.json();
  if (contacts.status === "ok") {
    return contacts.data;
  }

  throw new Error(contacts.code);
};

const readById = async (contactId: string): Promise<IContact> => {
  const visitorId = await getVisitorId();
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/${contactId}/userUid/${userUid}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "X-Visitor-Id": visitorId,
        Authorization: "Bearer " + token,
      },
    }
  );

  const contact: DefaultResponse<IContact> = await response.json();
  if (contact.status === "ok") {
    return contact.data as IContact;
  }

  throw new Error(contact.code);
};

const getTestDriveContact = async (): Promise<{
  exists: boolean;
  contact: IContact;
}> => {
  const userUid = localStorageGetItem("USER_UID");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/testDrive/${userUid}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
      },
    }
  );

  const contact: DefaultResponse<{ exists: boolean; contact: IContact }> =
    await response.json();
  if (contact.status === "ok") {
    return contact.data as { exists: boolean; contact: IContact };
  }

  throw new Error(contact.code);
};

const readFormsByContact = async (
  contactId: string
): Promise<FormToContact[]> => {
  const visitorId = await getVisitorId();
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/${contactId}/form`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "X-Visitor-Id": visitorId,
        Authorization: "Bearer " + token,
      },
    }
  );

  const contact: DefaultResponse<FormToContact[]> = await response.json();
  if (contact.status === "ok") {
    return contact.data as FormToContact[];
  }

  throw new Error(contact.code);
};

const addTag = async (
  tagId: string,
  contactId: string
): Promise<IUpdateContactResponse> => {
  const visitorId = await getVisitorId();
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/${contactId}/tag/userUid/${userUid}`,
    {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "X-Visitor-Id": visitorId,
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ tag: tagId }),
    }
  );

  const contact: DefaultResponse<IUpdateContactResponse> =
    await response.json();
  if (contact.status === "ok") {
    return contact.data as IUpdateContactResponse;
  }

  throw new Error(contact.code);
};

const addTagByEmail = async (
  tagId: string,
  email: string,
  userUid: string
): Promise<IUpdateContactResponse> => {
  const visitorId = await getVisitorId();
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/email/${email}/tag/userUid/${userUid}`,
    {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "X-Visitor-Id": visitorId,
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ tag: tagId }),
    }
  );

  const contact: DefaultResponse<IUpdateContactResponse> =
    await response.json();
  if (contact.status === "ok") {
    return contact.data as IUpdateContactResponse;
  }

  throw new Error(contact.code);
};

const setDefaultTestDrive = async (
  data: Omit<ISetTestDriveContactIRoute, "userUid">
): Promise<any> => {
  const userUid = localStorageGetItem("USER_UID");
  const response = await fetch(`${Configs.SERVER_URL}/contact/setTestDrive`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
    },
    body: JSON.stringify({ ...data, userUid }),
  });

  const contact: DefaultResponse<any> = await response.json();
  if (contact.status === "ok") {
    return contact.data as any;
  }

  throw new Error(contact.message);
};

const createManyFromImport = async (
  contacts: ICreateContact[]
): Promise<IContact[]> => {
  const visitorId = await getVisitorId();
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/contact/import`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      "X-Visitor-Id": visitorId,
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(contacts.map((c) => ({ ...c, userUid }))),
  });

  const contact: DefaultResponse<IContact[]> = await response.json();
  if (contact.status === "ok") {
    return contact.data as IContact[];
  }

  throw new Error(contact.message);
};

const updateManyFromImport = async (
  tagsId: string[],
  contacts: ImportExistingEmail[],
  isToUpdate: boolean
): Promise<IUpdateContactResponse> => {
  const visitorId = await getVisitorId();
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/import/userUid/${userUid}`,
    {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "X-Visitor-Id": visitorId,
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ tagsId, contacts, isToUpdate }),
    }
  );

  const contact: DefaultResponse<IUpdateContactResponse> =
    await response.json();
  if (contact.status === "ok") {
    return contact.data as IUpdateContactResponse;
  }

  throw new Error(contact.message);
};

const removeManyTags = async (
  tagsId: string[],
  contactsId: string[]
): Promise<IUpdateContactResponse> => {
  const visitorId = await getVisitorId();
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/many/tag/userUid/${userUid}/remove`,
    {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "X-Visitor-Id": visitorId,
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ tagsId, contacts: contactsId }),
    }
  );

  const contact: DefaultResponse<IUpdateContactResponse> =
    await response.json();
  if (contact.status === "ok") {
    return contact.data as IUpdateContactResponse;
  }

  throw new Error(contact.code);
};

const addAndRemoveManyTag = async (
  addTagIds: string[],
  removeTagIds: string[],
  contactIds?: string[],
  query?: FindAllContactWithFilterIRoute
): Promise<IUpdateContactResponse> => {
  const visitorId = await getVisitorId();
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/many/tag/userUid/${userUid}/add-remove`,
    {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "X-Visitor-Id": visitorId,
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        addTagIds,
        removeTagIds,
        contacts: contactIds,
        query,
      }),
    }
  );

  const contact: DefaultResponse<IUpdateContactResponse> =
    await response.json();
  if (contact.status === "ok") {
    return contact.data as IUpdateContactResponse;
  }

  throw new Error(contact.code);
};

const removeTag = async (
  tagId: string,
  contactId: string
): Promise<IUpdateContactResponse> => {
  const visitorId = await getVisitorId();
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/${contactId}/tag/userUid/${userUid}/remove`,
    {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "X-Visitor-Id": visitorId,
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({ tag: tagId }),
    }
  );

  const contact: DefaultResponse<IUpdateContactResponse> =
    await response.json();
  if (contact.status === "ok") {
    return contact.data as IUpdateContactResponse;
  }

  throw new Error(contact.code);
};

const update = async (
  {
    name,
    email,
    labels,
    tags,
    avatar,
    customFields,
    phone,
    firstName,
    lastName,
    billingStreet1,
    billingStreet2,
    billingCity,
    billingCountry,
    billingState,
    billingPostalCode,
    billingStreetNumber,
    billingPhoneCountryCode,
    billingPhone,
    billingFullAddress,
    shippingFullAddress,
    shippingStreetNumber,
    shippingStreet1,
    shippingStreet2,
    shippingCity,
    shippingCountry,
    shippingState,
    shippingPostalCode,
    shippingPhoneCountryCode,
    shippingPhone,
    testimonial,
  }: IUpdateContact,
  contactId: string
): Promise<IUpdateContactResponse> => {
  const visitorId = await getVisitorId();
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/${contactId}/userUid/${userUid}`,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "X-Visitor-Id": visitorId,
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        name,
        email,
        labels,
        tags,
        avatar,
        customFields,
        phone,
        firstName,
        lastName,
        billingStreet1,
        billingStreetNumber,
        billingStreet2,
        billingCity,
        billingCountry,
        billingState,
        billingPostalCode,
        billingPhoneCountryCode,
        billingFullAddress,
        billingPhone,
        shippingStreet1,
        shippingFullAddress,
        shippingStreetNumber,
        shippingStreet2,
        shippingCity,
        shippingCountry,
        shippingState,
        shippingPostalCode,
        shippingPhoneCountryCode,
        shippingPhone,
        testimonial,
      }),
    }
  );

  const contact: DefaultResponse<IUpdateContactResponse> =
    await response.json();
  if (contact.status === "ok") {
    return contact.data as IUpdateContactResponse;
  }

  throw new Error(contact.code);
};

const remove = async (contactId: string): Promise<IDeleteContact> => {
  const visitorId = await getVisitorId();
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/contact/${contactId}`, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + token,
      "X-Visitor-Id": visitorId,
    },
  });

  const contact: DefaultResponse<IDeleteContact> = await response.json();
  if (contact.status === "ok") {
    return contact.data as IDeleteContact;
  }

  throw new Error(contact.code);
};

async function removeCustomFieldFromContact(data: {
  contactId: string;
  customFieldId: string;
}) {
  const { contactId, customFieldId } = data;

  const visitorId = await getVisitorId();
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/custom_field/${contactId}/${customFieldId}`,
    {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "X-Visitor-Id": visitorId,
      },
    }
  );

  const contact: DefaultResponse<IContact> = await response.json();
  if (contact.status === "ok") {
    return contact.data as IContact;
  }

  throw new Error(contact.code);
}

const removeMany = async ({
  contactIds,
  query,
}: {
  contactIds?: string[];
  query?: FindAllContactWithFilterIRoute;
}): Promise<IDeleteContact> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const visitorId = await getVisitorId();
  const response = await fetch(`${Configs.SERVER_URL}/contact`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      "X-Visitor-Id": visitorId,
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ contactIds, query, userUid }),
  });

  const contact: DefaultResponse<IDeleteContact> = await response.json();
  if (contact.status === "ok") {
    return contact.data as IDeleteContact;
  }

  throw new Error(contact.code);
};

const sendConfirmation = async ({
  contactIds,
  query,
}: {
  contactIds?: string[];
  query?: FindAllContactWithFilterIRoute;
}): Promise<any> => {
  const visitorId = await getVisitorId();
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/confirmation/userUid/${userUid}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
        "X-Visitor-Id": visitorId,
      },
      body: JSON.stringify({ contactIds, query }),
    }
  );

  const confirmedEmail: DefaultResponse<any> = await response.json();
  if (confirmedEmail.status === "ok") {
    return confirmedEmail.data as IContact;
  }

  throw new Error(confirmedEmail.code);
};

const checkUserCreatedContacts = async ({
  contactIds,
}: {
  contactIds: string[];
}): Promise<boolean> => {
  const visitorId = await getVisitorId();
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/checkUserCreatedContacts`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
        "X-Visitor-Id": visitorId,
      },
      body: JSON.stringify({ contactIds }),
    }
  );

  const responseData: DefaultResponse<{ result: boolean }> =
    await response.json();
  if (responseData.status === "ok") {
    return responseData.data.result;
  }

  throw new Error(responseData.code);
};

const manyAdminUnsubscribed = async ({
  contactIds,
  query,
}: {
  contactIds?: string[];
  query?: FindAllContactWithFilterIRoute;
}): Promise<any> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const visitorId = await getVisitorId();
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/admin/unsub/${userUid}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
        "X-Visitor-Id": visitorId,
      },
      body: JSON.stringify({ contactIds, userUid, query }),
    }
  );

  if (response.ok) {
    const confirmedEmail: DefaultResponse<any> = await response.json();
    return confirmedEmail;
  }
};

const manyRevertAdminUnsubscribe = async ({
  contactIds,
  query,
}: {
  contactIds?: string[];
  query?: FindAllContactWithFilterIRoute;
}): Promise<any> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const visitorId = await getVisitorId();
  const response = await fetch(
    `${Configs.SERVER_URL}/contact/admin/not-confirmed/${userUid}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
        "X-Visitor-Id": visitorId,
      },
      body: JSON.stringify({ contactIds, userUid, query }),
    }
  );

  if (response.ok) {
    const confirmedEmail: DefaultResponse<any> = await response.json();
    return confirmedEmail;
  }
};

const manyAdminSuspend = async ({
  contactIds,
  query,
}: {
  contactIds?: string[];
  query?: FindAllContactWithFilterIRoute;
}): Promise<any> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const visitorId = await getVisitorId();

  const response = await fetch(
    `${Configs.SERVER_URL}/contact/admin/suspend/${userUid}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
        "X-Visitor-Id": visitorId,
      },
      body: JSON.stringify({ contactIds, userUid, query }),
    }
  );

  if (response.ok) {
    const confirmedEmail: DefaultResponse<any> = await response.json();
    return confirmedEmail;
  }
};

const manyAdminUnsuppress = async ({
  contactIds,
  query,
}: {
  contactIds?: string[];
  query?: FindAllContactWithFilterIRoute;
}): Promise<any> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const visitorId = await getVisitorId();

  const response = await fetch(
    `${Configs.SERVER_URL}/contact/admin/unsuppress/${userUid}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
        "X-Visitor-Id": visitorId,
      },
      body: JSON.stringify({ contactIds, query }),
    }
  );

  if (response.ok) {
    const unsuppressedContacts: DefaultResponse<any> = await response.json();
    return unsuppressedContacts;
  }
};

const addOrRemoveManyLabels = async ({
  data,
}: {
  data?: AddAndRemoveMultipleLabelsContactIRoute;
}): Promise<any> => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const visitorId = await getVisitorId();

  const response = await fetch(
    `${Configs.SERVER_URL}/contact/many/label/${userUid}/add-remove`,
    {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
        "X-Visitor-Id": visitorId,
      },
      body: JSON.stringify(data),
    }
  );

  if (response.ok) {
    const responseData: DefaultResponse<{ success: boolean }> =
      await response.json();
    return responseData;
  }
};

export const ContactApi = {
  create,
  read,
  readById,
  addTag,
  addTagByEmail,
  createManyFromImport,
  updateManyFromImport,
  removeTag,
  removeManyTags,
  readFormsByContact,
  countContactsByTagQueries,
  update,
  remove,
  removeMany,
  sendConfirmation,
  manyRevertAdminUnsubscribe,
  manyAdminUnsubscribed,
  manyAdminUnsuppress,
  addAndRemoveManyTag,
  checkDeleteCount,
  setDefaultTestDrive,
  getTestDriveContact,
  manyAdminSuspend,
  checkUserCreatedContacts,
  addOrRemoveManyLabels,
  removeCustomFieldFromContact,
};
